module.exports = "/_next/static/images/my-3e0c968342fcda345dae150d19ccc1fd.svg";